import { Button, Grid, MenuItem, Paper, TextField } from "@mui/material";

import { ReportOptions, ReportsFilters } from "../types";

interface ReportFiltersProps {
  filters: ReportsFilters;
  options: ReportOptions;
  onChange: (filters: Partial<ReportsFilters>) => void;
  onReset: () => void;
}

const ReportFilters = ({
  filters,
  options,
  onChange,
  onReset,
}: ReportFiltersProps) => {
  return (
    <Paper variant="outlined" sx={{ p: { xs: 1.5, md: 2 }, mb: 2.5, borderRadius: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            type="date"
            label="From"
            InputLabelProps={{ shrink: true }}
            value={filters.fromDate || ""}
            onChange={(event) => onChange({ fromDate: event.target.value })}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            type="date"
            label="To"
            InputLabelProps={{ shrink: true }}
            value={filters.toDate || ""}
            onChange={(event) => onChange({ toDate: event.target.value })}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Hub"
            value={filters.warehouseId || ""}
            onChange={(event) => onChange({ warehouseId: event.target.value })}
          >
            <MenuItem value="">All Hubs</MenuItem>
            {options.hubs.map((hub) => (
              <MenuItem key={hub.id} value={hub.id}>
                {hub.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Category"
            value={filters.categoryId || ""}
            onChange={(event) => onChange({ categoryId: event.target.value })}
          >
            <MenuItem value="">All Categories</MenuItem>
            {options.categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Supplier"
            value={filters.supplierId || ""}
            onChange={(event) => onChange({ supplierId: event.target.value })}
          >
            <MenuItem value="">All Suppliers</MenuItem>
            {options.suppliers.map((supplier) => (
              <MenuItem key={supplier.id} value={supplier.id}>
                {supplier.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <Button fullWidth variant="outlined" sx={{ height: 42 }} onClick={onReset}>
            Reset
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ReportFilters;
